import { zValidPeriod } from '../../../common/utils';
import { z } from 'zod/v3';

export const UserRoleSchema = z.object({
  id: z.number(),
  validPeriod: zValidPeriod(),
});

export const UserViewPermissionSchema = z
  .object({
    validPeriod: zValidPeriod(),
  })
  .and(
    z.union([
      z.object({
        dataObjectGroupId: z.number(),
        dataObjectDescriptionId: z.null(),
        type: z.enum(['I', 'O']),
      }),
      z.object({
        dataObjectGroupId: z.null(),
        dataObjectDescriptionId: z.number(),
        type: z.enum(['IN', 'OUT']),
      }),
    ]),
  );

export const UserBasicViewSchema = z.object({
  id: z.number(),
  username: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  nationalIdNumber: z.string().nullable(),
  validFrom: z.string().nullable(),
  validTo: z.string().nullable(),
});

export const UserViewSchema = UserBasicViewSchema.extend({
  roles: z.array(UserRoleSchema),
  viewPermissions: z.array(UserViewPermissionSchema),
});
